export const WEBSITE = {
    DOMAIN: 'www.docchatllc.com'
}